<template>
    <p class="tw-text-xs tw-text-red-500 tw-mb-1.5 tw-h-[14px] tw-mt-0.5">
        <slot />    
    </p>
</template>